import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MasterConstants } from '../../../../common/constants/master-constants';
// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { CppProductlabel } from '../../../../services/cpp/cpp-product-label.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { CommonService } from '../../../../services/common/common.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-product-label-landing',
  templateUrl: './product-label-landing.component.html',
  styleUrls: ['./product-label-landing.component.scss']
})
export class ProductLabelLandingComponent implements OnInit {
  @ViewChild('#placedProductLabelOrderTable', { read: MatSort }) productLabelOrderSort: MatSort;
  @ViewChild('placedProductLabelOrdersPaginator', { read: MatPaginator }) placedProductLabelOrdersPaginator: MatPaginator;
  private subscription = new Array<Subscription>();
  productLabelOrderDataSource: MatTableDataSource<any>;
  productLabelOrderList: any = [];
  searchTypeList: string[] = [];
  selectedValue: string;
  productFilters: any;
  filterValueList = new Array();
  fromOrderDateFilter: any;
  toOrderDateFilter: any;
  filter: any;
  isEvolveAccountRestriction = false;
  validateEvolveData: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  userMenuAccessList: any;
  readOnlyAccess = false;
  masterConstants = MasterConstants;
  productLabelOrderColumns: string[] = ["orderNumber", "accountName", "accountNumber", "orderDate", "viewOrder"];
  constructor(
    private cppProductlabelService: CppProductlabel,
    private loaderService: LoaderService,
    private router: Router,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private datePipe: DatePipe)
  { }

  ngOnInit(): void {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;    

      const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evolveAccessData) {
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER)) {
          this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
          if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
            this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);

          }
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }

    this.setSearchTypeList();
    this.resetPageFilter();
    this.getProductLabelOrders();
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // set the search filter list based on evolveaccountrestriction
  setSearchTypeList() {
    this.searchTypeList = ['Account Name', 'Account No', 'Order Number', 'Order Date'];

    this.selectedValue = this.searchTypeList[0];
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.cppTopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 220;
      $('.tableContainer').css('max-height', templateHeight + 'px');
    }, 100);

  }

  getProductLabelOrders() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppProductlabelService
      .getProductLabelOrders(this.filter)
      .subscribe(
        (result: any[]) => {
          this.productLabelOrderList = result;
          this.productLabelOrderDataSource = new MatTableDataSource(this.productLabelOrderList);
          this.productLabelOrderDataSource.paginator = this.placedProductLabelOrdersPaginator;
          this.productLabelOrderDataSource.paginator.firstPage();
          this.productLabelOrderDataSource.sort = this.productLabelOrderSort;

          this.loaderService.setLoaderStatus(false);
        },
        error => { this.loaderService.setLoaderStatus(false); }
      ));
  }

  createNewOrder() {
    this.router.navigate(['/cpp/cpp-product-label-form']);
  }

  // Reset Page Filter
  resetPageFilter() {
    this.productFilters = {    
      'AccountName': null,
      'TxtAccountNo': null,
      'AccountNo': [],    
      'FromOrderDate': null,
      'ToOrderDate': null,     
      'OrderNumber': null,    
    };

    this.filter = {    
      'accountName': null,
      'account': null,   
      'fromOrderDate': null,
      'toOrderDate': null,    
      'orderNumber': null,   
    };
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    this.validateInputText();
    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];       
          selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });       
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        // text Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
          this.filter.account = this.productFilters.TxtAccountNo.trim();
        }
        else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
          let strAct = '';
          this.productFilters.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });

          if (this.isEvolveAccountRestriction) {
            this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
          }
          else {
            this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          }

          if (this.productFilters.AccountNo == -1) {
            this.filter.account = '-1';
          }
          else {
            this.filter.account = strAct;
          }
        }
        else {
          this.filter.account = null;
        }
        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName.trim();
        }
        else {
          this.filter.accountName = null;
        }

        // Order Number
        if (this.productFilters.OrderNumber && this.productFilters.OrderNumber != '') {
          this.filterValueList.push('Order Number : ' + this.productFilters.OrderNumber);
          this.filter.orderNumber = this.productFilters.OrderNumber.trim();
        } else {
          this.filter.orderNumber = null;
        }

        if (this.productFilters.FromOrderDate
          && this.productFilters.FromOrderDate != null
          && this.productFilters.ToOrderDate
          && this.productFilters.ToOrderDate != null) {
          this.filterValueList.push('Order Date : (' + this.datePipe.transform(this.productFilters.FromOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToOrderDate, 'MM/dd/yyyy') + ')');
          this.filter.fromOrderDate = new Date(this.productFilters.FromOrderDate).toDateString();
          this.filter.toOrderDate = new Date(this.productFilters.ToOrderDate).toDateString();
        }
      }
      this.setAccSummaryTableHeight();
    }
  }

  // To remove/clear selected chip search filter
  removeSelectedFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'Order Number':
        this.productFilters.OrderNumber = null;
        this.filter.orderNumber = null;
        break;
      case 'Order Date':
        this.productFilters.FromOrderDate = null;
        this.productFilters.ToOrderDate = null;
        this.filter.fromOrderDate = null;
        this.filter.toOrderDate = null;
        this.fromOrderDateFilter = '';
        this.toOrderDateFilter = '';
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetPageFilter();
    this.validateOrderDateFilter('clearAll', '');
    this.getProductLabelOrders();
    this.setAccSummaryTableHeight();
  }

  // Clear selected filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeSelectedFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.getProductLabelOrders();
      }
      this.setAccSummaryTableHeight();
    }
  }

  // validate the order date filter on search filters
  validateOrderDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromOrderDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToOrderDate) {
        var toDate = new Date(this.productFilters.ToOrderDate);
        this.fromOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toOrderDate') {
      toDate = new Date($event.value);
      this.fromOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromOrderDate) {
        var fromDate = new Date(this.productFilters.FromOrderDate);
        this.toOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromOrderDateFilter = '';
      this.toOrderDateFilter = '';
    }
  }

  validateNumText(numInput) {
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }

  // Validate the search input text
  validateInputText() {
    if (this.productFilters.TxtAccountNo) {
      this.productFilters.TxtAccountNo = this.validateNumText(this.productFilters.TxtAccountNo);
    }
    if (this.productFilters.OrderNumber) {
      this.productFilters.OrderNumber = this.validateNumText(this.productFilters.OrderNumber);
    }
  }

  // Generate PDF
  generatedPdf(order: any) {
    this.cppProductlabelService.generatePdf(order.orderNumber);
  }

}
